import { render, staticRenderFns } from "./NewItems.vue?vue&type=template&id=0f41f344&scoped=true&"
import script from "./NewItems.vue?vue&type=script&lang=js&"
export * from "./NewItems.vue?vue&type=script&lang=js&"
import style0 from "./NewItems.vue?vue&type=style&index=0&id=0f41f344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f41f344",
  null
  
)

export default component.exports